mainApp.component('activePassiveFailoverConfiguration', {
    templateUrl: '/public/components/configuration/failover/active-passive-failover-configuraion.component.html',
    bindings: {
        config: "<?",
        onConfigChanged: "&?",
        path: "<?",
        defaults: "<",
        precedencesList: "<?",
        defaultLabel: "<",
    },
    controller: function($scope, $controller, FailoverConfigurationService) {
        const ctrl = this;
        _.merge(ctrl, $controller('BaseFailoverConfigController', {$scope: $scope, ctrl: ctrl,}));

        ctrl.failoverDelayItems = [{name: 'failoverDelayFrom1To2', label: 'Failover to precedence 2 (sec/min)', model: 'failoverDelayFrom1To2Value, failoverDelayFrom1To2Unit', requiredPrecedence: 2},
                                   {name: 'failoverDelayFrom2To3', label: 'Failover to precedence 3 (sec/min)', model: 'failoverDelayFrom2To3Value, failoverDelayFrom2To3Unit', requiredPrecedence: 3}];

        ctrl.updateDefaultsLabel = function() {
            if(!ctrl.labels) {
                ctrl.labels = {};
            }
            ctrl.labels.failover = ctrl.defaultLabel + "(" + ctrl.defaults.failoverValue + " " + FailoverConfigurationService.unitToLabelText(ctrl.defaults.failoverUnit) + ")";
            ctrl.labels.failoverDelayFrom1To2 = ctrl.defaultLabel + "(" + ctrl.defaults.failoverDelayFrom1To2Value + " " + FailoverConfigurationService.unitToLabelText(ctrl.defaults.failoverDelayFrom1To2Unit) + ")";
            ctrl.labels.failoverDelayFrom2To3 = ctrl.defaultLabel + "(" + ctrl.defaults.failoverDelayFrom2To3Value + " " + FailoverConfigurationService.unitToLabelText(ctrl.defaults.failoverDelayFrom2To3Unit) + ")";
            ctrl.labels.fallbackTime = ctrl.defaultLabel + "(" + ctrl.defaults.fallbackValue + " " + FailoverConfigurationService.unitToLabelText(ctrl.defaults.fallbackUnit) + ")";
            ctrl.labels.acceptableNaturalOrder = ctrl.defaultLabel + "(" + precedenceNameToLabel(ctrl.precedencesList[ctrl.defaults.acceptableNaturalOrder]) +  ")";
            ctrl.labels.fallbackFactor = ctrl.defaultLabel + "(" + ctrl.defaults.fallbackFactor + ")";
        }

        ctrl.isDisabled = function (requiredPrecedence) {
            return ctrl.precedencesList[requiredPrecedence] == undefined;
        }

        ctrl.doOnChanges = function(){
            ctrl.precedences = angular.copy(ctrl.precedencesList);
            removeHighestPrecedence();
        }

        ctrl.qualityThresholdsChanged = function(current, previous, path) {
            ctrl.config.activePassiveQualityThresholds = current;
            ctrl.onConfigChanged({current: ctrl.config, previous: ctrl.originalConfig, path: ctrl.path});
        }

        function precedenceNameToLabel(precedence) {
            precedence = precedence.replace("(", "");
            precedence = precedence.replace(")", "");
            precedence = precedence.replace(" ", "-");
            return precedence;
        }

        // removing max since cant fail-over to it
        function removeHighestPrecedence() {
            if(ctrl.precedences[3] != undefined) {
                delete ctrl.precedences[3];
            } else if (ctrl.precedences[2] != undefined) {
                delete ctrl.precedences[2];
            }
        }

    }
});